const pillars = [
  {
    num: '01',
    title: 'One Partner',
    description: 'One reliable point of contact for your essential business IT requirements.',
  },
  {
    num: '02',
    title: 'Complete Support',
    description: 'From purchasing and installation to troubleshooting and ongoing maintenance.',
  },
  {
    num: '03',
    title: 'Built for Business',
    description: 'Practical technology solutions focused on reliability, productivity and long-term support.',
  },
];

export default function WhyTechBridge() {
  return (
    <section id="about" className="py-20 md:py-28" style={{ backgroundColor: '#00164A' }}>
      <div className="max-w-site mx-auto px-4 md:px-6">
        <div className="animate-on-scroll mb-16 md:mb-20">
          <span className="font-label text-xs uppercase tracking-[0.2em]" style={{ color: '#0167F8' }}>Why TechBridge</span>
          <h2 className="mt-4 font-heading text-[36px] md:text-[48px] font-bold text-background-50 tracking-[-0.02em] leading-[1.14]">
            Your IT should work.<br />Not slow you down.
          </h2>
          <p className="mt-4 text-base md:text-lg text-background-200/80 leading-relaxed max-w-[580px]">
            Technology problems shouldn&apos;t interrupt your business. TechBridge brings hardware,
            networking and technical support together under one dependable technology partner.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 animate-on-scroll">
          {pillars.map((pillar, i) => (
            <div
              key={pillar.num}
              className={`relative py-8 md:py-10 px-0 md:px-8 lg:px-10 ${
                i < 2 ? 'border-b md:border-b-0 md:border-r border-background-200/15' : ''
              }`}
            >
              <span className="font-heading text-[64px] md:text-[80px] font-extrabold leading-none text-background-200/5 select-none absolute top-0 left-0 md:left-8 lg:left-10">
                {pillar.num}
              </span>
              <div className="relative z-10">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">{pillar.title}</h3>
                <p className="text-sm md:text-base text-background-200/70 leading-relaxed">{pillar.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}